<template>
    <transition name="fade">
  <div class="loading" v-cloak>
    <div class="container">
    <div class="columns">
    <div class="column">
        <div class="margin-auto">
      <img :src="'../../../static/logos/ooshzonelogo.png'" alt="OOSH Zone Australia" width="auto" height="28">
    </div>
    </div>
    </div>
    <div class="columns">
    <div class="column">
      <p>Choose your centre: </p>
        <div class="margin-auto">
            <a @click="changeSchool('stgregs')"  :class="{'margin-top button is-dark': true }">
              <span>St Gregory’s College Junior School</span>
            </a>
            <a @click="changeSchool('maryimmaculate')"  :class="{'margin-top button is-dark': true }">
              <span>Mary Immaculate Catholic Parish</span>
            </a>
        </div>

    <!-- <a href="#" class="button is-loading is-white"></a> -->
    </div>
    </div>
                <!-- <div class="columns">
    <div class="column">
           <div class="margin-auto myTime">
      <img :src="'../../../static/logos/MeetingNQS.png'" alt="My Time Our Place" width="auto">
      <img :src="'../../../static/logos/MyTimeOurPlace.png'" alt="My Time Our Place" width="auto">

           </div>
      </div>
      </div> -->
    </div>
  </div>
  </transition>
</template>

<script>
export default {
  name: 'Loading',
  props: ['preloading', 'stopLoading', 'changeSchooll'],
  methods: {
    changeSchool: function (newSchool) {
      this.changeSchooll(newSchool)
      this.stopLoading()
    }
  }
}
</script>

<style scoped>
img {
  height: auto;
  width: 256px;
}
.margin-auto {
  margin: 0 auto;
  padding: 20px 0;
}
@media screen and (max-width: 619px) {
  .margin-top:nth-child(2),
  .margin-top:nth-child(3) {
    margin-top: 20px;
  }
}
.is-dark:hover {
  color: #e67e22;
}
a {
  color: #e67e22;
}
a:hover {
  color: #e67d22b6;
}
.myTime img {
  width: 92px;
  height: auto;
  margin: 0 auto;
  vertical-align: middle;
  margin-right: 20px;
}
@media screen and (min-width: 500px) {
.myTime img:first-child {
  margin-right: 160px;
  height: 92px;
  width: auto;
}
}
.loading .container {
  margin: auto;
}
.loading {
  /* display: flex; */
  /* align-items: center; */
   display: flex;
    align-items: center;
  background: #fff;
  height: 100vh;
  margin: auto;
  padding: 3rem 1rem;
}
[v-cloak] {
  display: none;
}
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .75s;
}

.fade-enter-active {
  transition-delay: .75s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Loading.vue